import { IconWrapper } from '../runtime';
export default IconWrapper('garbage-can-open', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M7.99962 6.74998V10.25M3.77462 6.99998L4.36455 12.8992C4.44123 13.666 5.08647 14.25 5.8571 14.25H10.1421C10.9128 14.25 11.558 13.666 11.6347 12.8992L12.2246 6.99998M5.06221 2.16833L9.46387 1.23273M1.65234 5.36511L13.8792 2.76621",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});